// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"43e9bd57","320":"18497d9f","953":"c55f351c"}[chunkId] + ".chunk.css";
};